// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-songwriters-message {
  margin-top: 4rem;
  padding-top: 4rem;
  margin-bottom: 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.no-songwriters-message p:first-child {
  font-size: 2.8rem;
  line-height: 3.5rem;
  padding-bottom: 0.8rem;
}
.no-songwriters-message p:first-child strong {
  font-weight: 700;
}
.no-songwriters-message p:nth-child(2) {
  font-size: 1.6rem;
  line-height: 2.4rem;
  font-weight: 500;
  width: 53rem;
  padding-bottom: 3rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/ProfileScene/ProfileSceneSongwriterTab/NoSongwritersMessage/index.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AADF;AAGE;EACE,iBAAA;EACA,mBAAA;EACA,sBAAA;AADJ;AAGI;EACE,gBAAA;AADN;AAKE;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,oBAAA;AAHJ","sourcesContent":["@use '@Styles/variables';\n\n.no-songwriters-message {\n  margin-top: 4rem;\n  padding-top: 4rem;\n  margin-bottom: 4rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  p:first-child {\n    font-size: 2.8rem;\n    line-height: 3.5rem;\n    padding-bottom: 0.8rem;\n\n    strong {\n      font-weight: 700;\n    }\n  }\n\n  p:nth-child(2) {\n    font-size: 1.6rem;\n    line-height: 2.4rem;\n    font-weight: 500;\n    width: 53rem;\n    padding-bottom: 3rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
